<template>
    <div class="aba-emrpesa">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns is-flex-wrap">
                <div
                    class="column"
                    :class="[
                        permissao.create &&
                        !assProdutoIntegracao &&
                        permissaoProduto.create &&
                        !produtoIntegracao
                            ? 'is-4'
                            : permissao.create &&
                              !assProdutoIntegracao &&
                              (!permissaoProduto.create || produtoIntegracao)
                            ? 'is-6'
                            : permissaoProduto.create &&
                              !produtoIntegracao &&
                              (!permissao.create || assProdutoIntegracao)
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-produto"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissao.create &&
                        !assProdutoIntegracao &&
                        !produtoIntegracao &&
                        permissaoProduto.create
                            ? 'is-2'
                            : permissao.create &&
                              !assProdutoIntegracao &&
                              (!permissaoProduto.create || produtoIntegracao)
                            ? 'is-3'
                            : permissaoProduto.create &&
                              !produtoIntegracao &&
                              (!permissao.create || assProdutoIntegracao)
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <label v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <div class="column is-3" v-if="!assProdutoIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalProdutosNaoAssociados()"
                    >
                        {{ $t('vincular-produto') }}
                    </button>
                </div>
                <div
                    class="column is-3"
                    v-if="permissaoProduto.create && !produtoIntegracao && permissao.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: isPromotor
                                    ? 'new-produto'
                                    : 'ven-produto-dados-cadastrais-new',
                                query: {
                                    tela: 'empresa-produto',
                                    id: $route.params.id,
                                    name: $route.params.name,
                                    dadoscadastrais: $parent.abaSelecionada,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-produto') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprodutoempresa"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div
                            v-if="f.key == 'descricao' && !assProdutoIntegracao && permissao.update"
                        >
                            <a @click="showModalProdutosNaoAssociados(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else-if="f.key.includes('multiplicador')">
                            {{ getDecimal(props.row[f.key]) }}
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assProdutoIntegracao"
                                class="action-button"
                                :type="props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['replicapda'] == 3"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <ProdutoVinculaModal
                        :idempresa="$route.params.id"
                        @fecharModal="fecharModal"
                        v-if="selected == null"
                    />
                    <ProdutoEditaModal :selected="selected" @fecharModal="fecharModal" v-else />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import ProdutoService from '@/services/vendas/empresa/abas/AssProdutoEmpresaService';
import ProdutoVinculaModal from '@/components/vendas/empresa/modal/ProdutoNewModal.vue';
import ProdutoEditaModal from '@/components/vendas/empresa/modal/ProdutoEditModal.vue';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        ProdutoVinculaModal,
        ProdutoEditaModal,
    },
    data() {
        return {
            assProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSPRODUTOEMPRESA'
            ),
            produtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRODUTO'),
            assprodutoempresa: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'multiplicadorweb', width: null, sortable: true, sortFn: null },
                { key: 'multiplicadortrocaweb', width: null, sortable: true, sortFn: null },
                { key: 'multiplicador', width: null, sortable: true, sortFn: null },
                { key: 'multiplicadortroca', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: null, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new ProdutoService(this.$http, this.$router),
            permissao: false,
            permissaoProduto: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 4, label: 'todos' },
            situacoes: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            valorScale: this.$store.state.empresas.data.filter(
                (f) => (f.id = this.$route.params.id)
            )[0].valordecimalplaces,
            selected: null,

            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-dados-cadastrais-produto'
            );
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'empresa',
                'pro-empresa-dados-cadastrais-produto'
            );
        }

        this.permissaoProduto = this.hasPermissionAccess(
            'admin',
            'gerenciar-produtos',
            'admin-gerenciar-produtos'
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'empresa' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacao.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assprodutoempresa = value;
                    this.isEmpty = this.assprodutoempresa.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idempresa, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else if (this.isPromotor) {
                return this.service.findAllPromotor(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            if (this.isPromotor) {
                return body.content.map((m) => {
                    return {
                        idassprodutoempresa: m.idassprodutoempresa,
                        descricao: m.proproduto.descricao,
                        codigo: m.proproduto.idproprodutoerp,
                        multiplicador: m.multiplicador,
                        multiplicadortroca: m.multiplicadortroca,
                        multiplicadorweb: m.multiplicadorweb,
                        multiplicadortrocaweb: m.multiplicadortrocaweb,
                        replicapda: m.replicapda,
                    };
                });
            } else {
                return body.content.map((m) => {
                    return {
                        idassprodutoempresa: m.idassprodutoempresa,
                        descricao: m.produto.descricao,
                        codigo: m.produto.idprodutoerp,
                        multiplicador: m.multiplicador,
                        multiplicadortroca: m.multiplicadortroca,
                        multiplicadorweb: m.multiplicadorweb,
                        multiplicadortrocaweb: m.multiplicadortrocaweb,
                        replicapda: m.replicapda,
                    };
                });
            }
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            if (field == 'codigo') field = 'idprodutoerp';
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 3
                    ? 'msg-erro-ao-reativar-associacao-produto'
                    : 'msg-erro-ao-desativar-associacao-produto';

            let tempAssprodutoempresa = {
                idassprodutoempresa: this.delete.idassprodutoempresa,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssprodutoempresa)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-produto'
                                : 'msg-sucesso-ao-desativar-associacao-produto';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assprodutoempresa) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assprodutoempresa);
            else if (this.isPromotor) return this.service.updateSituacaoPromotor(assprodutoempresa);
            else return this.service.updateSituacaoAgro(assprodutoempresa);
        },
        showModalProdutosNaoAssociados(val = null) {
            this.selected = val;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
        decimalPlaces(n) {
            let places = typeof n != 'number' ? 2 : n > 8 ? 8 : n < 0 ? 0 : n;
            return {
                minimumFractionDigits: places,
                maximumFractionDigits: places,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-emrpesa {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
